import { faPlusSquare, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ErrorMessage, FieldArray } from "formik";
import { Button, Col, FormGroup, Input, Label, Row } from "reactstrap";
import {
  placeholderNoOptions,
  placeholderSelectSimple,
  placeholderText,
} from "../../../../shared/helpers/placeHolders";
import {
  validateEndDate,
  validateJobFunction,
  validateJobPlace,
  validateJobType,
  validateStartDate,
  validateTasks,
} from "../../../../shared/helpers/validateFields";
import { IStepper } from "../../../../shared/model/IStepper";
import { IJobExperience } from "../../../../shared/model/job-experience.model";
import { ButtonsGroup } from "../ButtonsGroup";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { newJobExperience } from "../../PostulateModel";
import { jobTypeEnum } from "../../../../shared/selectors/jobTypeEnums";
import { to_ISelect_Enum } from "../../../../shared/mutator/dataTransformSelect";
import { jobFunctionEnum } from "../../../../shared/selectors/jobFunctionEnum";
import { isDisabled } from "../../../../shared/helpers/isDisabledEndDate";
import { customStyles } from "../custom-selector-styles";

interface IProps {
  formik: any;
  showErrorsInputs: boolean;
  setShowErrorsInputs: (data: boolean) => void;
}
const animatedComponents = makeAnimated();
export const WorkExperience = (props: IProps) => {
  const { formik, showErrorsInputs } = props;

  return (
    <>
      {/* Experiencia Laboral */}
      <Row className="title-form">Experiencia laboral</Row>
      <FieldArray
        name="jobExperiences"
        render={(arrayHelpers) => (
          <div>
            {formik.values.jobExperiences &&
              formik.values.jobExperiences.map(
                (currentValue: IJobExperience, index: number) => (
                  <Row
                    className="mt-5 animate__animated animate__fadeIn"
                    key={index}
                  >
                    {index > 0 && <hr></hr>}
                    <Col xs={12}>
                      <Row>
                        <Col className="d-flex justify-content-end">
                          <Button
                            className="btn-delete-item"
                            outline
                            onClick={() => {
                              arrayHelpers.remove(index);
                              props.setShowErrorsInputs(false);
                            }} // remove a field from the list
                          >
                            <span className="d-md-inline">
                              <FontAwesomeIcon icon={faTrash} />
                            </span>
                          </Button>
                        </Col>
                      </Row>
                      <Row className="container-inputs-form">
                        <Input
                          type="text"
                          hidden
                          name={`jobExperiences[${index}].id`}
                          readOnly
                          value={currentValue.id || "0"}
                        ></Input>
                        <Col>
                          <FormGroup>
                            <Label
                              className={
                                validateJobPlace(
                                  formik,
                                  index,
                                  showErrorsInputs
                                )
                                  ? "text-danger"
                                  : ""
                              }
                            >
                              Empresa*
                            </Label>
                            <Input
                              type="text"
                              name={`jobExperiences[${index}].jobPlace`}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur(
                                `jobExperiences[${index}].jobPlace`
                              )}
                              value={currentValue?.jobPlace || ""}
                              className={
                                validateJobPlace(
                                  formik,
                                  index,
                                  showErrorsInputs
                                )
                                  ? "is-invalid"
                                  : ""
                              }
                              placeholder={placeholderText()}
                            />
                            {validateJobPlace(
                              formik,
                              index,
                              showErrorsInputs
                            ) && (
                              <div className="invalid-feedback">
                                {formik.errors?.jobExperiences[index].jobPlace}
                              </div>
                            )}
                          </FormGroup>
                        </Col>
                        <Col>
                          <FormGroup>
                            <Label>Tipo de trabajo</Label>
                            <Select
                              isClearable
                              name={`jobExperiences[${index}].jobType`}
                              placeholder={placeholderSelectSimple()}
                              noOptionsMessage={() => placeholderNoOptions()}
                              components={animatedComponents}
                              options={jobTypeEnum()}
                              value={to_ISelect_Enum(
                                formik.values.jobExperiences[index].jobType,
                                jobTypeEnum()
                              )}
                              onChange={(e: any) => {
                                formik.setFieldValue(
                                  `jobExperiences[${index}].jobType`,
                                  e?.value ? e.value : null
                                );
                              }}
                              onBlur={formik.handleBlur(
                                `jobExperiences[${index}].jobType`
                              )}
                              className={`select-postulate`}
                              styles={customStyles}
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row className="container-inputs-form">
                        <Col md="6">
                          <FormGroup>
                            <Label>Puesto laboral</Label>
                            <Input
                              type="text"
                              name={`jobExperiences[${index}].jobTitle`}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur(
                                `jobExperiences[${index}].jobTitle`
                              )}
                              value={currentValue?.jobTitle || ""}
                              placeholder={placeholderText()}
                            />
                          </FormGroup>
                        </Col>
                        <Col>
                          <FormGroup>
                            <Label
                              className={
                                validateJobFunction(
                                  formik,
                                  index,
                                  showErrorsInputs
                                )
                                  ? "text-danger"
                                  : ""
                              }
                            >
                              Función del puesto*
                            </Label>
                            <Select
                              name={`jobExperiences[${index}].jobFunction`}
                              placeholder={placeholderSelectSimple()}
                              noOptionsMessage={() => placeholderNoOptions()}
                              components={animatedComponents}
                              options={jobFunctionEnum()}
                              value={to_ISelect_Enum(
                                formik.values.jobExperiences[index].jobFunction,
                                jobFunctionEnum()
                              )}
                              onChange={(e: any) => {
                                formik.setFieldValue(
                                  `jobExperiences[${index}].jobFunction`,
                                  e.value
                                );
                              }}
                              onBlur={formik.handleBlur(
                                `jobExperiences[${index}].jobFunction`
                              )}
                              className={`select-postulate ${
                                validateJobFunction(
                                  formik,
                                  index,
                                  showErrorsInputs
                                )
                                  ? "is-invalid"
                                  : ""
                              }`}
                              styles={customStyles}
                            />
                            {validateJobFunction(
                              formik,
                              index,
                              showErrorsInputs
                            ) && (
                              <div className="invalid-feedback">
                                {
                                  formik.errors.jobExperiences[index]
                                    .jobFunction
                                }
                              </div>
                            )}
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row className="container-inputs-form">
                        <Col>
                          <FormGroup>
                            <Label
                              className={
                                validateStartDate(
                                  formik,
                                  index,
                                  showErrorsInputs
                                )
                                  ? "text-danger"
                                  : ""
                              }
                            >
                              Fecha de inicio*
                            </Label>
                            <Input
                              type="date"
                              name={`jobExperiences[${index}].startDate`}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur(
                                `jobExperiences[${index}].startDate`
                              )}
                              value={currentValue?.startDate || ""}
                              className={
                                validateStartDate(
                                  formik,
                                  index,
                                  showErrorsInputs
                                )
                                  ? "is-invalid"
                                  : ""
                              }
                              placeholder={placeholderText()}
                            />
                            {validateStartDate(
                              formik,
                              index,
                              showErrorsInputs
                            ) && (
                              <div className="invalid-feedback">
                                {formik.errors.jobExperiences[index].startDate}
                              </div>
                            )}
                          </FormGroup>
                        </Col>
                        <Col>
                          <FormGroup>
                            <Label
                              className={
                                validateEndDate(formik, index)
                                  ? "text-danger"
                                  : ""
                              }
                            >
                              Fecha de fin
                            </Label>
                            <Input
                              type="date"
                              name={`jobExperiences[${index}].endDate`}
                              onChange={formik.handleChange(
                                `jobExperiences[${index}].endDate`
                              )}
                              onBlur={formik.handleBlur(
                                `jobExperiences[${index}].endDate`
                              )}
                              value={currentValue?.endDate || ""}
                              placeholder={placeholderText()}
                              className={
                                validateEndDate(formik, index)
                                  ? "is-invalid"
                                  : ""
                              }
                              disabled={isDisabled(
                                formik.values.jobExperiences[index].toPresent,
                                index
                              )}
                            />
                            <div className="invalid-feedback">
                              <ErrorMessage
                                name={`jobExperiences[${index}].endDate`}
                              />
                            </div>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row className="mt-3 justify-content-end">
                        <Col
                          md="6"
                          className="text-right d-flex justify-content-end"
                        >
                          <FormGroup className="form-check">
                            <Input
                              type="checkbox"
                              name={`jobExperiences[${index}].toPresent`}
                              onChange={(e) => {
                                formik.setFieldValue(
                                  `jobExperiences[${index}].toPresent`,
                                  e.target.checked
                                );
                                if (e.target.checked) {
                                  formik.setFieldValue(
                                    `jobExperiences[${index}].endDate`,
                                    null
                                  );
                                }
                              }}
                              onBlur={formik.handleBlur(
                                `jobExperiences[${index}].toPresent`
                              )}
                              checked={
                                formik.values.jobExperiences[index].toPresent ||
                                false
                              }
                              className="form-check-input"
                            />
                            <label className="form-check-label pt-0 ml-3">
                              Actualmente
                            </label>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row className="container-inputs-form">
                        <Col md="12">
                          <FormGroup>
                            <Label
                              className={
                                validateTasks(formik, index, showErrorsInputs)
                                  ? "text-danger"
                                  : ""
                              }
                            >
                              Tareas desempeñadas*
                            </Label>
                            <Input
                              type="textarea"
                              name={`jobExperiences[${index}].tasks`}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur(
                                `jobExperiences[${index}].tasks`
                              )}
                              value={currentValue?.tasks || ""}
                              className={
                                validateTasks(formik, index, showErrorsInputs)
                                  ? "is-invalid"
                                  : ""
                              }
                              placeholder={placeholderText()}
                            />
                            {validateTasks(formik, index, showErrorsInputs) && (
                              <div className="invalid-feedback">
                                {formik.errors.jobExperiences[index].tasks}
                              </div>
                            )}
                          </FormGroup>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                )
              )}
            <Row>
              <Col className="d-flex justify-content-end align-items-end">
                <Button
                  className={`${
                    formik.values.jobExperiences &&
                    formik.values.jobExperiences.length > 0
                      ? "btn-link"
                      : "btn-link-card"
                  }`}
                  outline
                  onClick={() => arrayHelpers.push(newJobExperience)}
                >
                  {formik.values.jobExperiences &&
                  formik.values.jobExperiences.length > 0 ? (
                    <>
                      <span>
                        <FontAwesomeIcon icon={faPlusSquare} />
                      </span>
                      Agregar experiencia
                    </>
                  ) : (
                    "Agregar experiencia laboral"
                  )}
                </Button>
              </Col>
            </Row>
            {formik.values.jobExperiences &&
              formik.values.jobExperiences.length > 0 && <hr></hr>}
          </div>
        )}
      />
    </>
  );
};
